import styled from "styled-components";

export const MyFiller = styled.div`min-height: 100px;`